import copy from './copy'

const directives = {
  copy
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}



// WEBPACK FOOTER //
// ./src/directives/index.js